/*
 * SpecPlus scroll-reveal — applies Dawn's native reveal animation
 * (.scroll-trigger.animate--slide-in) to our custom sections, then removes
 * .scroll-trigger--offscreen as each enters the viewport. Uses Dawn's own
 * base.css animation styles — no custom animation CSS.
 */
(function () {
  'use strict';

  var PREFIXES = [
    'CustomHero-', 'VehicleFinder-', 'CollGrid-', 'Brands-', 'FCS-', 'TWI-', 'ITC-',
    'RS-', 'GAL-', 'FAQ-', 'NL-', 'CB-', 'CC-', 'PB-', 'CT-', 'AB-', 'ST-', 'AM-',
    'VS-', 'CTA-', 'RP-', 'MainVehicle-', 'PDP-'
  ];
  var selector = PREFIXES.map(function (p) { return '[id^="' + p + '"]'; }).join(',');

  // Respect reduced-motion: leave everything visible, do nothing.
  if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  var io = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (entry.isIntersecting) {
        entry.target.classList.remove('scroll-trigger--offscreen');
        io.unobserve(entry.target);
      }
    });
  }, { rootMargin: '0px 0px -5% 0px', threshold: 0.05 });

  function observe(scope) {
    (scope || document).querySelectorAll(selector).forEach(function (el) {
      if (el.dataset.specReveal === 'true') return;
      el.dataset.specReveal = 'true';
      el.classList.add('scroll-trigger', 'animate--slide-in', 'scroll-trigger--offscreen');
      io.observe(el);
    });
  }

  function start() { observe(document); }

  if (document.readyState !== 'loading') start();
  else document.addEventListener('DOMContentLoaded', start);

  // Theme editor: reveal immediately so nothing stays hidden while editing.
  document.addEventListener('shopify:section:load', function (e) {
    observe(e.target);
    e.target.querySelectorAll('.scroll-trigger--offscreen').forEach(function (el) {
      el.classList.remove('scroll-trigger--offscreen');
    });
  });
})();
